'use client';

import { c as _c } from "react/compiler-runtime";
import { MonitorUp } from 'lucide-react';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

/**
 * Shown in the browser once a page opens in the desktop app. It is where "Always open links in the
 * app" is turned on, after the handoff has worked, and off again.
 */
export function HandoffInterstitial(t0) {
  const $ = _c(19);
  const {
    alwaysOpen,
    onAlwaysOpenChange,
    onContinue
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onContinue) {
    t1 = () => {
      const handleKeyDown = function handleKeyDown(event) {
        if (event.key === "Escape") {
          onContinue();
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    t2 = [onContinue];
    $[0] = onContinue;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onContinue) {
    t3 = event_0 => {
      if (event_0.target === event_0.currentTarget) {
        onContinue();
      }
    };
    $[3] = onContinue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mx-auto mb-4 flex size-10 items-center justify-center rounded-lg bg-primary/10 text-primary"><MonitorUp aria-hidden="true" className="size-5" /></div>;
    t5 = <h2 className="text-base font-semibold">Opening in the cubic app</h2>;
    t6 = <p className="mt-2 text-sm text-muted-foreground">Keep going there. If the app didn't come forward, continue here.</p>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== alwaysOpen || $[9] !== onAlwaysOpenChange) {
    t7 = alwaysOpen ? <p className="text-sm text-muted-foreground">Links open in the app automatically.{" "}<button type="button" className="text-foreground underline underline-offset-4" onClick={() => onAlwaysOpenChange(false)}>Ask me each time</button></p> : <Button onClick={() => onAlwaysOpenChange(true)}>Always open links in the app</Button>;
    $[8] = alwaysOpen;
    $[9] = onAlwaysOpenChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onContinue) {
    t8 = <Button onClick={onContinue} variant="outline">Continue in browser</Button>;
    $[11] = onContinue;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="w-full max-w-sm rounded-xl border bg-card p-6 text-center shadow-xl" role="status">{t4}{t5}{t6}<div className="mt-5 flex flex-col gap-2">{t7}{t8}</div></div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 p-6 backdrop-blur-sm" data-testid="handoff-interstitial-backdrop" onClick={t3}>{t9}</div>;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}